import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login/Login';
import Main from '@/views/Main';

import moduleList from '@/views/setting/moduleSetting/moduleList';
import moduleAddEdit from '@/views/setting/moduleSetting/moduleAddEdit';

import affairModuleList from '@/views/affairs/moduleList';
import affairModuleDetail from '@/views/affairs/moduleDetail';
import affairMessageDetail from '@/views/affairs/messageDetail';

import accounting from '@/views/accounting/accounting';

import outerMessageAdd from '@/views/outer/messageAdd';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/login'
        }, {
            path: '/login',
            name: 'login',
            component: Login
        }, {
            path: '/outer/messageAdd',
            name: 'outerMessageAdd',
            component: outerMessageAdd
        }, {
            path: '/main',
            name: 'main',
            component: Main,
            children: [{
                path: '',
                redirect: 'affairs/moduleList'
            },
                {
                    path: 'setting',
                    redirect: 'setting/moduleList'
                },
                {
                    path: 'setting/moduleList',
                    name: 'moduleList',
                    component: moduleList,
                    // meta: {
                    //     permissionPath: '/throughTrain/addTrainType'
                    // }
                }, {
                    path: 'setting/moduleAddEdit',
                    name: 'moduleAddEdit',
                    component: moduleAddEdit,
                    // meta: {
                    //     permissionPath: '/throughTrain/addTrainType'
                    // }
                }, {
                    path: 'affairs',
                    redirect: 'affairs/moduleList'
                }, {
                    path: 'affairs/moduleList',
                    name: 'affairModuleList',
                    component: affairModuleList,
                }, {
                    path: 'affairs/moduleDetail',
                    name: 'affairModuleDetail',
                    component: affairModuleDetail,
                    // meta: {
                    //     permissionPath: '/throughTrain/batchRecord'
                    // }
                }, {
                    path: 'affairs/messageDetail',
                    name: 'affairMessageDetail',
                    component: affairMessageDetail,
                    // meta: {
                    //     permissionPath: '/throughTrain/batchRecord'
                    // }
                }, {
                    path: 'accounting',
                    name: 'accounting',
                    component: accounting,
                    // meta: {
                    //     permissionPath: '/throughTrain/getTrainTypeStatisticalList'
                    // }
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js